<script>
/**
 * 公共事業場データ補完
 * 公共事業場選択画面
 */
import { mapActions } from "vuex";
import PrefectureList from '../../../../mixins/PrefectureList'
import Confirm from "../../../../components/Confirm.vue";
/**
 * 公共事業場データ補完
 * 公共事業場選択モーダル
 */
export default {
  name: "PublicPlaceSearchModal",
  components: {Confirm},
  mixins: [PrefectureList],
  props: {
    /**
     * 本ダイアログ表示制御
     */
    dialog: {
      type: Boolean,
      default: false
    },
    /**
     * 対象マニフェスト運搬詳細
     */
    targetItem: {
      type: Object,
      default: () => null,
    },
    /**
     * JWNETマニフェスト一覧で選択されたマニフェストID
     */
    targetSelectableIds: {
      type: Array,
      default: () => [],
    },
    /**
     * JWNETマニフェスト一覧検索結果表示日時
     */
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      /* 検索ブロック表示制御 */
      panel: null,
      /* ページ番号 */
      page: 1,
      /* paginationの最大数 */
      totalVisible: 7,
      selectedItem: null,
      selectedRow: null,
      tableHeaders: [
        { text: "事業者コード", value: "code", sortable: false, width: "10%" },
        { text: "公共積替事業場", value: "name", sortable: false, width: "40%" },
        { text: "事業場住所", value: "address", sortable: false, width: "50%" },
      ],
      trader_locations: [],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      searchForm: {
        code: null,
        name: null,
        zip_code: null,
        prefecture_code: null,
        address: null,
        phone_number: null,
      },
      withSameName: false,
    }
  },
  watch: {
    dialog(val) {
      Object.assign(this.$data.searchForm, this.$options.data().searchForm);
      Object.assign(this.$data.pagination, this.$options.data().pagination);
      this.trader_locations = [];
      this.withSameName = false;
      this.scrollToTop();
      this.unSelectRow();
      if (val) {
        this.searchTraderLocations();
      }
    },
  },
  computed: {
  },
  methods: {
    ...mapActions('DriverTransferPublicPlace', {
      fetchPublicPlaces: 'index',
      updatePublicPlace: 'update',
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1;
      this.unSelectRow();
      this.searchTraderLocations();
    },
    /**
     * ページ チェンジイベント
     */
    pageChangeEvent () {
      this.unSelectRow();
      this.searchEmissions();
    },
    /**
     * 一覧行 クリックイベント
     * @param item
     * @param row
     */
    rowClickEvent(item, row) {
      this.selectedItem = item;
      this.selectedRow = row;
      row.select(true);
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let modalOption = {
        title: '確認',
        message: '紐付けします。よろしいですか？',
        options: {width: 320, isCancelButton: true}
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.registerPublicPlace();
        }
      })
    },
    /**
     * 一覧検索
     */
    searchTraderLocations () {
      const params = {
        page: this.page,
        code: this.searchForm.code,
        name: this.searchForm.name,
        zip_code: this.searchForm.zip_code,
        prefecture_code: this.searchForm.prefecture_code,
        address: this.searchForm.address,
        phone_number: this.searchForm.phone_number,
      };
      this.fetchPublicPlaces({ params: params }).then((content) => {
        this.trader_locations = content.public_places;
        this.pagination = content.pagination;
      });
    },
    /**
     * 登録処理
     */
     registerPublicPlace () {
      const parameters = {
        code: this.selectedItem.code,
        jwnet_manifest_id: this.targetItem .ma_jwnet_manifest_id,
        searched_at: this.searchedAt,
        jwnet_manifest_ids: this.withSameName ? this.targetSelectableIds : [],
      }
      this.updatePublicPlace({ id: this.targetItem.id, params: parameters }).then(() => {
        this.$emit("registerCallback")
      })
    },
    unSelectRow () {
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null
      this.selectedRow = null
    },
    scrollToTop () {
      const elements = document.getElementsByClassName('publicPlaceSearchBody');
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      elements[0].scrollTop = 0;
    },
  }
}
</script>

<template>
  <div>
    <v-dialog
      :value="dialog"
      width="1400"
      scrollable
      @click:outside="closeButtonClickEvent"
      @close="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>
            公共事業場紐付け
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-subtitle>
          <fieldset class="transfer-header pa-2 mt-2">
            <legend>JWNET公共事業場情報</legend>
            <v-row dense>
              <v-col cols="12" md="2">
                <h6>{{ this.targetItem.manifest_no }}</h6>
                <span>区間{{ this.targetItem.section_no }}運搬先</span>
              </v-col>
              <v-col cols="12" md="3">
                <h6>{{ this.targetItem.jwnet_trader_location_name }}</h6>
                <span>{{ this.targetItem.jwnet_trader_location_address }}</span>
              </v-col>
            </v-row>
          </fieldset>
        </v-card-subtitle>
        <v-card-text
          class="publicPlaceSearchBody"
          style="height: 45vh"
        >
          <v-row>
            <v-col>
              <v-expansion-panels
                v-model="panel"
                accordion
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    class="panel-header-color panel-selectable"
                  >
                    <strong>
                      <v-icon class="panel-header-color"> mdi-magnify </v-icon>
                      &nbsp;条件を指定して検索
                    </strong>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.code"
                              dense
                              hide-details="auto"
                              label="事業場コード"
                              clearable
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.code = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.name"
                              dense
                              hide-details="auto"
                              label="事業場名"
                              clearable
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.name = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.zip_code"
                              dense
                              hide-details="auto"
                              label="郵便番号"
                              clearable
                              outlined
                              persistent-hint
                              persistent-placeholder
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.zip_code = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-autocomplete
                              v-model="searchForm.prefecture_code"
                              :items="prefList"
                              clearable
                              dense
                              hide-details="auto"
                              label="都道府県"
                              outlined
                              persistent-placeholder
                              placeholder="例）東京都"
                              rounded
                              style="font-size: 80%"
                              @click:clear="() => { searchForm.prefecture_code = null; searchButtonClickEvent(); }"
                              @change="searchButtonClickEvent"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.address"
                              dense
                              label="市区町村・町域・詳細住所"
                              hide-details="auto"
                              clearable
                              outlined
                              persistent-placeholder
                              placeholder="例）中央区日本橋兜町１－２－３○○ビル○階"
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.address = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="searchForm.phone_number"
                              autocomplete="off"
                              dense
                              hint="電話番号を「-」ハイフン「( )」込みで入力します"
                              hide-details="auto"
                              label="電話番号"
                              clearable
                              outlined
                              persistent-placeholder
                              placeholder="例）000-0000-0000"
                              persistent-hint
                              rounded
                              style="font-size: 80%"
                              @blur="searchButtonClickEvent"
                              @click:clear="() => { searchForm.phone_number = null; searchButtonClickEvent(); }"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-divider />
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="primary"
                          @click="searchButtonClickEvent"
                        >
                          検索
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-data-table
                :headers="tableHeaders"
                :items="trader_locations"
                :items-per-page="-1"
                disable-sort
                hide-default-footer
                single-select
                @click:row="rowClickEvent"
              >
                <template v-slot:[`item.code`]="{ item }">
                  <div>{{ item.code }}</div>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.name"
                    style="width: 400px;"
                  >{{ item.name }}</div>
                </template>
                <template v-slot:[`item.address`]="{ item }">
                  <div>〒{{ item.zip_code }}</div>
                  <div
                    class="text-ellipsis text-sm-caption"
                    :title="item.address"
                    style="width: 500px;"
                  >{{ item.address }}</div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <!-- ページャ -->
          <v-row class="mb-15">
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
          <!-- /ページャ -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-checkbox
            v-model="withSameName"
            label="同じ事業場名のマニフェスト（紐付け未設定）にも紐付けする"
            class="mr-5"
            dense
            persistent-hint
            persistent-placeholder
            style="font-size: 80%"
          />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="selectedItem === null"
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm ref="confirm" />
  </div>
</template>
